import styled from 'styled-components';
import { FieldLabel, InputField } from '../../../../components/Form';
import { theme } from '../../../../styles/theme';
import { PrimaryButton } from '../../../../components/Button';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  max-width: 1163px;
  margin-top: 24px;
`;

export const BoldedFieldLabel = styled(FieldLabel)`
  font-weight: 500;
`;

export const WiderPrimaryButton = styled(PrimaryButton)`
  padding-left: 8px;
  padding-right: 8px;
`;

export const SettingsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const TosWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 512px;
  color: ${theme.colors.secondary600};
`;

export const TosHeaderWrapper = styled.div`
  font-weight: 600;
  line-height: 18px;
`;

export const TosBodyWrapper = styled.div`
  font-weight: 400;
  line-height: 18px;
`;

export const StyledInputField = styled(InputField)`
  max-width: 512px;
  width: 512px;
`;

export const ButtonsRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;
